import type * as React from 'react';
import { ConfirmDeleteDialog } from '@verclam/ui-kit';

type Props = {
	readonly visible: boolean;
	readonly accountName: string;
	readonly onHide: () => void;
	readonly onAccept: () => void;
};

/** Strengthened confirmation: shortening a duration permanently deletes data on the next nightly purge. */
const RetentionReductionDialog: React.FC<Props> = ({ visible, accountName, onHide, onAccept }) => {
	return (
		<ConfirmDeleteDialog
			visible={visible}
			onHide={onHide}
			header="Réduire la durée de conservation"
			message="Les enregistrements audio et les dossiers archivés plus anciens que la nouvelle durée seront supprimés définitivement lors de la prochaine purge, chaque nuit. Cette suppression est irréversible."
			confirmText={accountName}
			confirmLabel={`Veuillez récrire ${accountName} pour réduire la durée de conservation.`}
			acceptLabel="Réduire la durée"
			rejectLabel="Annuler"
			acceptCallback={onAccept}
		/>
	);
};

export default RetentionReductionDialog;
